import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@getgreenline/blaze-ui";
import { ssoClient, ssoEnabled } from "../../lib/sso-client";
import { useAuthStore } from "../../stores/auth-store";
import { startRefreshTimer } from "../../lib/token-refresh";

export function CallbackPage() {
  const navigate = useNavigate();
  const setTokens = useAuthStore((s) => s.setTokens);
  const [error, setError] = useState<string | null>(null);
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    if (!ssoClient || !ssoEnabled) {
      navigate("/campaigns", { replace: true });
      return;
    }

    ssoClient
      .handleCallback()
      .then((tokens) => {
        if (!tokens) return; // still redirecting (discovery → realm)
        setTokens(tokens);
        startRefreshTimer(Date.now() + tokens.expires_in * 1000);
        navigate("/campaigns", { replace: true });
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : "Authentication failed");
      });
  }, [navigate, setTokens]);

  if (error) {
    return (
      <div className="tw:flex tw:h-screen tw:flex-col tw:items-center tw:justify-center tw:gap-4">
        <p className="tw:text-sm tw:text-destructive">{error}</p>
        <a
          href="/sso/login"
          className="tw:text-sm tw:text-primary tw:underline"
        >
          Try again
        </a>
      </div>
    );
  }

  return (
    <div className="tw:flex tw:h-screen tw:items-center tw:justify-center">
      <Spinner className="tw:h-8 tw:w-8 tw:text-muted-foreground" />
    </div>
  );
}
